define([
    './slider',
    './_site',
    '@fancyapps/fancybox'
], function(
    Slider,
    Site
) {
    const $inlineGallerySlider = $('.content-gallery--inline');

    $inlineGallerySlider.each(function (index) {
        const link = $(this).find('a[data-type="image"]');
        link.attr('data-fancybox', 'image-slider_' + index);
        link.attr('data-fancybox-trigger', index);
    });


    // -------------------
    // BINDS
    // -------------------

    Slider.create($inlineGallerySlider, {
        slide: '.content-gallery__slide',
        fade: false,
        draggable: true,
        slidesToScroll: 1,
        waitForAnimate: false,
        lazyLoad: 'ondemand',
        dots: false,
        infinite: false,
        variableWidth: true,
        prevArrow: '<span class="content-gallery__arrow content-gallery__arrow--prev" title="Previous"></span>',
        nextArrow: '<span class="content-gallery__arrow content-gallery__arrow--next" title="Next"></span>',
        responsive: [
            {
                breakpoint: Site.breakpoints.sm,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                    variableWidth: false,
                },
            },
        ],
    });
});
